module.exports = __webpack_public_path__ + "static/img/ci.c070fec.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/samsung-svc/ci.gif
// module id = QJft
// module chunks = 0